import { useContext } from "react";
import { FormContext } from "../../App";
import style from "./ErrorMessage.module.css";

interface ErrorMessageProps {
  name?: string;
  errorText?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ name, errorText }) => {
  const { errors } = useContext(FormContext);
  const error = errorText ?? (name ? errors[name]?.message : "");

  return <span className={style.errorMessage}>{error}</span>;
};
export default ErrorMessage;
